import _ from "underscore";

import Backbone from "pages/common/lib/backbone-helpers";
import { escapeRegExp } from "util/string-utils";

var BaseCollection = Backbone.Collection.extend({
    search: function (fields, query) {
        if (query.trim() === ``) return this;

        var escapedQuery = escapeRegExp(query.trim());

        var pattern = new RegExp(escapedQuery, `i`);

        // If fields is a string, add it to an empty array so we can test multiple fields in a loop
        fields = Array.isArray(fields) ? fields : [fields];

        return _(
            this.filter(function (model) {
                var fieldMatch = false;
                _.each(fields, function (field) {
                    if (pattern.test(model.get(field))) {
                        fieldMatch = true;
                        return;
                    }
                });
                return fieldMatch;
            })
        );
    },

    setComparator: function (field) {
        if (field !== this.comparator) {
            this.comparator = field;
            this.sort();
        } else {
            this.models = this.models.reverse();
            this.trigger(`sort`, this);
        }
    }
});

export default BaseCollection;
